import { LI, UL } from "../../../../../AbstractElements";
import { useAppSelector } from "../../../../../ReduxToolkit/Hooks";
import InboxEmailContent from "./InboxEmailContent";
import MailPagination from "./MailPagination";
import { TabPane } from "reactstrap";

const InboxContent = () => {
  const { inboxEmail, page } = useAppSelector((state) => state.letterBox);

  return (
    <TabPane tabId="1" >
      <div className="mail-body-wrapper">
        <UL className="simple-list">
          {inboxEmail.map((data, i) => (
            <LI className={`inbox-data ${page ? i < 8 ? "hidden" : "" : i < 8 ? "" : "hidden" }`} key={i}>
              <InboxEmailContent data={data} ids={i} />
            </LI>
          ))}
        </UL>
        <MailPagination />
      </div>
    </TabPane>
  );
};

export default InboxContent;
